import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SearchModel, SearchResultModel } from 'src/common';
import { environment } from 'src/environments/environment';
import { SupplierModel } from './supplier.model';

const localApiUrl = `${environment.apiUrl}/RequestOpnSupplierList`;

@Injectable()
export class SuppliersService {

    constructor(private http: HttpClient) { }

    searchForOpnSupplierList(search: SearchModel,id:number): Promise<SearchResultModel<SupplierModel>> {
        return this.http.post<SearchResultModel<SupplierModel>>(`${localApiUrl}/SearchForOpnSupplierList/${id}`,search).toPromise();
    }



}
